import { createBaseStore } from '@/zustand/create-store';
import { STORAGE_KEYS } from '@/zustand/storage-keys';
import { ServerTime } from '@/zustand/server-time/server-time';

const initialState: ServerTime = {
	serverTime: null
};

export const useServerTimeStore = createBaseStore<ServerTime>(STORAGE_KEYS.SERVER_TIME_STORAGE, initialState, undefined, {
	shouldPersist: false
});
